I18n.translations || (I18n.translations = {});
I18n.translations["cs"] = I18n.extend((I18n.translations["cs"] || {}), {
  "javascript": {
    "actions": {
      "copy": "kopírovat"
    },
    "confirmation": {
      "countdown": {
        "one": "You will be redirected after %{count} second...",
        "other": "You will be redirected after %{count} seconds..."
      },
      "messages": {
        "cancel": "Payment has been cancelled",
        "failure": "Your payment has been declined",
        "pending": "Your payment is pending",
        "success": "Your payment is accepted"
      },
      "to_website": "Back to merchant"
    },
    "options": {
      "or": "Nebo",
      "please_select": "Prosím zvolte...",
      "select_day": "Zvolte den",
      "select_month": "Zvolte měsíc",
      "select_year": "Zvolte rok"
    },
    "qr_page": {
      "scan_qr_code": "Scan the QR Code to finalize your Pix transaction"
    },
    "turning_card": {
      "full_name": "Celé jméno",
      "month": "měsíc",
      "thru": "platné",
      "valid": "do",
      "year": "rok"
    },
    "wpf_form": {
      "cnpj": {
        "label": "CNPJ",
        "placeholder": "xx.xxx.xxx/xxxx-xx"
      },
      "consumer_name": "Consumer name",
      "country_select_prompt": "Vyberte zemi",
      "cpf": {
        "label": "CPF",
        "placeholder": "xxx.xxx.xxx-xx"
      },
      "cpf_cnpj": "CPF/CNPJ",
      "document_id": "Document"
    }
  }
});
